import { isArray, isObject, startCase, upperCase, words } from 'lodash'
import moment from 'moment'
import { Accordion, Icon } from 'semantic-ui-react'

import { findBrowserIcon, findOSIcon } from '@/utilities/UserAgentIconUtil'

import messages from './messages'

function renderActorDetails(label: any, value: any) {
  return (
    <span>
      <strong>{label}</strong>
      {`: ` + value}
    </span>
  )
}

export default (onAccordionClicked: any, openSections: any, intl: any) => [
  {
    property: '@principalEmail',
    header: {
      label: 'Actor'
    },
    cell: {
      formatters: [
        (id: any, { rowData }: any) => {
          const cellValue = []
          if (rowData['@principalType'] === 'connector') {
            cellValue.push(
              {
                label: intl && intl.formatMessage(messages.name),
                value: rowData['@principalName'] || ''
              },
              {
                label: intl && intl.formatMessage(messages.type),
                value: rowData['@connectorType'] || ''
              }
            )
          }
          return (
            <div>
              <strong>{upperCase(rowData['@principalType'])}</strong>
              <p>
                <em>{rowData['@principalEmail'] || <em>{rowData['@principalId']}</em>}</em>
                {cellValue.map(actorDetails => {
                  return <p key={actorDetails.label}>{renderActorDetails(actorDetails.label, actorDetails.value)}</p>
                })}
              </p>
            </div>
          )
        }
      ]
    }
  },
  {
    property: 'message',
    header: {
      label: 'Event'
    },
    cell: {
      formatters: [
        (id: any, { rowData }: any) => {
          const cellValue = []
          if (rowData['@spaceName']) {
            cellValue.push(
              <span>
                <strong>{startCase('spaceName')}</strong>
                {`: ` + rowData['@spaceName']}
              </span>
            )
          }
          Object.entries(rowData['data']).forEach(([key, value]) => {
            if (key !== 'event') {
              const row = (
                <span>
                  <strong>{startCase(key)}</strong>
                  {`: ` + value}
                </span>
              )
              if (isArray(value) && value.length > 0) {
                cellValue.push(<strong>{startCase(key)}</strong>)
                const isStringsArray = value.every(v => typeof v === 'string')
                if (isStringsArray) {
                  value.forEach(val => {
                    cellValue.push(<span className="push-5">{val}</span>)
                  })
                } else {
                  value.forEach(val => {
                    Object.entries(val).forEach(([key, value]) => {
                      cellValue.push(<span className="push-5">{startCase(key) + ': ' + value}</span>)
                    })
                  })
                }
              } else if (isObject(value)) {
                cellValue.push(<strong>{startCase(key)}</strong>)
                Object.entries(value).forEach(([key, value]) => {
                  cellValue.push(<span className="push-5">{startCase(key) + ': ' + JSON.stringify(value)}</span>)
                })
              } else {
                cellValue.push(row)
              }
            }
          })
          let titleEvent = words(rowData['message'].toString()).join(' ')
          if (titleEvent.includes('WORKSHOP')) {
            titleEvent = titleEvent.replace('WORKSHOP', 'BUILDER')
          }
          return (
            <div className="log">
              <strong>{titleEvent}</strong>
              <Accordion fluid>
                <Accordion.Title
                  active={openSections().includes(rowData._index)}
                  index={rowData._index}
                  onClick={onAccordionClicked}
                >
                  {intl && intl.formatMessage(messages.details)}
                  <Icon name={`angle ${openSections().includes(rowData._index) ? 'up' : 'down'}`} />
                </Accordion.Title>
                <Accordion.Content active={openSections().includes(rowData._index)} index={rowData._index}>
                  {cellValue.map((value, index) => {
                    return <p key={index}>{value}</p>
                  })}
                </Accordion.Content>
              </Accordion>
            </div>
          )
        }
      ]
    }
  },
  {
    property: '@timestamp',
    header: {
      label: 'TimeStamp'
    },
    cell: {
      formatters: [(id: any, { rowData }: any) => moment(rowData['@timestamp']).format('lll')]
    }
  },
  {
    property: 'Browser',
    header: {
      label: 'Browser'
    },
    cell: {
      props: {
        style: {
          width: 30
        }
      },
      formatters: [
        (id: any, { rowData }: any) => {
          return <div className={'icon ' + findBrowserIcon(rowData['@userAgent'])} title={rowData['@userAgent']} />
        }
      ]
    }
  },
  {
    property: 'OS',
    header: {
      label: 'OS'
    },
    cell: {
      props: {
        style: {
          width: 30
        }
      },
      formatters: [
        (id: any, { rowData }: any) => {
          return <div className={'icon ' + findOSIcon(rowData['@userAgent'])} title={rowData['@userAgent']} />
        }
      ]
    }
  }
]
